<template>
  <div style="height:100%">
    <div style="height:92%;border-radius:8px;padding-top: 50px">
      <el-form :model="addParams" :rules="rules" ref="addParams" label-width="160px" size="small" style="width:800px">
        <el-form-item label="中文标题" prop="zhTitle">
          <el-input v-model="addParams.zhTitle"></el-input>
        </el-form-item>
        <el-form-item label="英文标题" prop="enTitle">
          <el-input v-model="addParams.enTitle"></el-input>
        </el-form-item>
        <el-form-item label="中文内容" prop="zhContent">
          <el-input v-model="addParams.zhContent" type="textarea" :rows="6"></el-input>
        </el-form-item>
        <el-form-item label="英文内容" prop="enContent">
          <el-input v-model="addParams.enContent" type="textarea" :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-left: 160px">
        <el-button type="primary" @click="editSubMit('addParams')" size="mini">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path:'/y-scope-info',
      addParams: {
        id:"",
        enTitle: "",
        zhTitle: "",
        title:"",
        zhContent:"",
        enContent:""
      },
      rules: {
        enTitle: [
          { required: true, message: '请输入英文标题', trigger: 'blur' }
        ],
        zhTitle: [
          { required: true, message: '请输中文标题', trigger: 'blur' }
        ],
        zhContent: [
          { required: true, message: '请输入中文内容', trigger: 'blur' }
        ],
        enContent: [
          { required: true, message: '请输英文内容', trigger: 'blur' }
        ],
      },
    };
  },
  created() {
    this.getInfo()
  },
  methods:{
    getInfo() {
      this.axios({
        method: "get",
        url: this.path+"/detail"
      }).then((res) => {
        if(res.data.data != null && res.data.data != undefined){
          this.addParams = res.data.data;
          if(this.addParams.title != '' && this.addParams.title != null && this.addParams.title != undefined){
            let titleObj = JSON.parse( this.addParams.title)
            this.$set( this.addParams,"zhTitle", titleObj.zh)
            this.$set( this.addParams,"enTitle", titleObj.en)
          }
          if(this.addParams.content != '' && this.addParams.content != null && this.addParams.content != undefined){
            let contentObj = JSON.parse( this.addParams.content)
            this.$set( this.addParams,"zhContent", contentObj.zh)
            this.$set( this.addParams,"enContent", contentObj.en)
          }
        }
      });
    },

    editSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }else {
          let titleObj = {}
          titleObj.zh = this.addParams.zhTitle
          titleObj.en = this.addParams.enTitle
          this.addParams.title = JSON.stringify(titleObj)
          let contentObj = {}
          contentObj.zh = this.addParams.zhContent
          contentObj.en = this.addParams.enContent
          this.addParams.content = JSON.stringify(contentObj)
          this.axios({
            method: "post",
            url: this.path+"/add",
            data: this.addParams,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormEdit = false;
              this.$message({message: "修改成功",type: "success"});
              this.list();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
  }
};
</script>

<style>

</style>